// The one fund colour palette (moved from strategy/AllocationHero.vue, 2026-10-31, for the Risk edge map).
// Never redefine these elsewhere: import FUND_META / fundMeta.
//
// Fund hues follow the app-wide entity colors (PortfolioPill.vue). GGE is
// re-stepped from the pill's #ff9800 to #ff7043 here only: adjacent to the
// gold amber in a stacked bar, #ff9800 fails the CVD/normal-vision
// separation check (deutan ΔE 7.2, normal 10.2); #ff7043 passes (12.1/19.6).

export interface FundMeta { label: string; color: string }

export const FUND_META: Record<string, FundMeta> = {
  BGA:  { label: 'BGA',  color: '#6ea8df' },
  JH:   { label: 'JH',   color: '#4caf50' },
  GOLD: { label: 'Gold', color: '#f6c542' },
  GGE:  { label: 'GGE',  color: '#ff7043' },
  JAPAN: { label: 'Japan', color: '#e879a6' },
  // Charteris Phase 3: the server lists CHARTERIS only for an entitled shared-pot user
  // (AllocationStatusEndpoints.SharedPotFundOrder). Light silver — far from the dark grey cash remainder.
  CHARTERIS: { label: 'Charteris', color: '#c0c7d0' },
  // AMATI Phase 3 (2026-10-13): listed only for an entitled shared-pot user, like CHARTERIS. Copper.
  AMATI: { label: 'Amati', color: '#c8794a' },
  // MINERS (Phase 1C 2026-10-25): gated like the others; gold-leaf amber, distinct from Gold's yellow and Amati's copper.
  MINERS: { label: 'Miners', color: '#d9a441' },
  // JAPANESG (2026-10-28): gated like the others; teal, distinct from Japan's pink, JH's green, BGA's blue and the cash purple.
  JAPANESG: { label: 'Japan ESG', color: '#14b8a6' },
  // TECH (2026-10-28): gated like the others; indigo, distinct from JH's green, BGA's light blue, Japan ESG's teal and the cash purple.
  TECH: { label: 'Tech', color: '#6366f1' },
  // ELECTRUM (2026-10-31): gated like the others; lime, distinct from Amati's copper, Miners' amber, Gold's yellow, JH's green and Japan ESG's teal.
  ELECTRUM: { label: 'Electrum', color: '#a3e635' },
  // JHTECH, ASIATECH, BARINGSOIL, SPWORLD (2026-10-31): gated, dark. Crimson, dark cyan, oil brown and slate:
  // distinct from Japan's pink, Japan ESG's teal, GGE's orange, Miners' amber and the grey unknown/silver.
  JHTECH: { label: 'JHTech', color: '#e11d48' },
  ASIATECH: { label: 'AsiaTech', color: '#0e7490' },
  BARINGSOIL: { label: 'BaringsOil', color: '#7c4a1e' },
  SPWORLD: { label: 'SPWorld', color: '#475569' },
  // SMALLCAP (2026-10-31): gated, dark. Olive, distinct from Electrum's lime, JH's green and SPWorld's slate.
  SMALLCAP: { label: 'SmallCap', color: '#808000' },
}

export const CASH_COLOR = '#b98af0'

const UNKNOWN_COLOR = '#9e9e9e'

/** The fund's palette entry; an unknown id gets a neutral grey with the id as its label. */
export function fundMeta(fundId: string): FundMeta {
  return FUND_META[fundId] ?? { label: fundId, color: UNKNOWN_COLOR }
}
